<div class="container-fluid d-flex align-items-center justify-content-center min-vh-100 bg-light">
    <div class="col-md-6 col-lg-4" style="padding-bottom: 5%;">
      <div class="text-center mb-4">
        <img src="../../../assets/logo-sigvaris-group.jpg" alt="Sigvaris Group Logo" class="img-fluid mb-3" style="max-width: 200px; height: 120px;">
      </div>
      <div class="card custom-card">
        <div class="card-body" style="padding-left: 25px; padding-right: 25px;">
          <h2 class="card-title text-center mb-3 mt-4" style="font-weight: bold;">Account Activation</h2>
          <p class="text-center mb-4">Click on the link below to confirm the activation of your account.</p>

          @if(this.errorToConfirm){
            <p class="alert alert-danger text-center mb-4">Unable to activate your account.</p>
          }

          @if(!this.errorToConfirm && this.showSuccessMessage) {
            <p class="alert alert-success text-center mb-4">Your account has been activated successfully.</p>
          }

          <button type="submit" (click)="onConfirm()" 
            class="mt-4 mb-4 j7 j8 an j9 ja ft fu bn fj fk fv fw fl fm am e8 b3 e6 bt bu jb jc ju je q r s ds bw cv by cx c2" 
            style="width: 100%;height: 50px;">Activate your account</button>
        </div>
      </div>
    </div>
  </div>